import * as React from "react";
import * as moment from "moment";
import * as _ from "underscore";

import { AppShape, EmploymentShape, HurdleShape, DocTypes } from "@eave/shared/types/api";
import { Button } from "carbon-components-react";
import { Save16 } from "@carbon/icons-react";
import { FormattedDate } from "react-intl";
import { connect } from "react-redux";
import Select from "react-select";
import { DocumentUploader } from "../../../DocumentUploader";
import { getFileDownloadBaseURL } from "../../../../config";
import LabeledInput from "../../../LabeledInput";
import APIClient from "../../../APIClient";
import { loadApp } from "../../actions";

const mapUnderwriterStateToProps = (state, ownProps) => ({
  documents: ownProps.documents,
  documentType: ownProps.documentType,
  prompt: ownProps.prompt,
  onUpload: ownProps.onUpload,
  ownerEntityType: ownProps.ownerEntityType,
  ownerEntityID: ownProps.ownerEntityID,
  applicationID: ownProps.applicationID,
});

const mapUnderwriterDispatchToProps = dispatch => ({
  updateApplication: (dispatchType, payload) => {
    loadApp(dispatch, payload.id);
  },
});

const UnderwriterDocumentUploader = connect(
  mapUnderwriterStateToProps,
  mapUnderwriterDispatchToProps,
)(DocumentUploader as any);

interface VVoEForEmploymentProps {
  app: AppShape;
  employment: EmploymentShape;
  hurdle: HurdleShape;
  dispatch?: Function;
}

class VVoEForEmployment extends React.Component<VVoEForEmploymentProps, any> {
  constructor(props) {
    super(props);
    this.state = {
      selectedDocument: null,
      vvoe: _.clone(props.employment.verbal_verification_of_employment),
    };
  }

  onSave() {
    const appID = this.props.app.id;
    const empID = this.props.employment.id;
    APIClient.post(`/${appID}/verbal_verification_of_employment/${empID}`, this.state.vvoe).then(
      () => {
        loadApp(this.props.dispatch, this.props.app.id);
      },
    );
  }

  handleSelectChange(fieldName, option) {
    const newState = this.state;
    newState.vvoe[fieldName] = option ? option.value : "";
    this.setState(newState);
  }

  handleTextChange(ev) {
    const newState = this.state;
    newState.vvoe[ev.target.name] = ev.target.value || null;
    this.setState(newState);
  }

  toggleDocUploader() {
    this.setState({
      showingDocumentUploader: !this.state.showingDocumentUploader,
    });
  }

  componentDidMount() {
    const documents = this.getDocumentOptions();
    if (documents.length > 0) {
      this.setState({ selectedDocument: documents[0].value });
    }
  }

  getDocumentOptions() {
    const { app, employment } = this.props;
    return _.chain(app.documents)
      .filter(
        (doc: any) =>
          doc.owner_entity_id === employment.id && doc.owner_entity_type === "employment",
      )
      .map((doc: any) => ({
        label: doc.type,
        value: doc.s3_key,
      }))
      .value();
  }

  borrowerName(borrowerEntity: number) {
    const { borrowers } = this.props.app;
    return `${borrowers[borrowerEntity].first_name} ${borrowers[borrowerEntity].last_name}`;
  }

  renderQuestions() {
    const options = [
      { value: "", label: <span className="hurdles-editor__emdash">—</span> },
      { value: true, label: "Yes" },
      { value: false, label: "No" },
    ];

    const questions = [
      {
        name: "employer_contact_verification_method",
        label: "How was the employer's contact information verified through a 3rd party?",
        type: "text",
        options: null,
      },
      {
        name: "employer_contact_phone",
        label: "What phone number did you call?",
        type: "text",
        options: null,
      },
      {
        name: "employer_contact_first_name",
        label: "Employer contact -- first name",
        type: "text",
        options: null,
      },
      {
        name: "employer_contact_last_name",
        label: "Employer contact -- last name",
        type: "text",
        options: null,
      },
      {
        name: "employer_contact_title",
        label: "Employer contact -- title",
        type: "text",
        options: null,
      },
      {
        name: "employer_contact_date",
        label: "Date of contact with employer",
        type: "date",
        options: null,
      },
      {
        options,
        name: "borrower_currently_employed",
        label: "Is the borrower currently employed with this employer?",
        type: "select",
      },
      {
        options,
        name: "borrower_employment_status_active",
        label: "Is the borrower's employment status active (not on leave)?",
        type: "select",
      },
      {
        name: "borrower_start_date",
        label: "What is the borrower's start date?",
        type: "date",
        options: null,
      },
      {
        name: "borrower_title",
        label: "What is the borrower's title?",
        type: "text",
        options: null,
      },
      {
        name: "additional_information",
        label: "Additional Information / Notes",
        type: "textarea",
        options: null,
      },
    ];

    return (
      <section className="vvoe-questionnaire">
        {this.state.showingDocumentUploader && this.renderDocumentUploader()}
        <Button onClick={this.toggleDocUploader.bind(this)}>
          {this.state.showingDocumentUploader ? "Cancel" : "Upload Worknumber Verification"}
        </Button>
        <div className="vvoe-questions">
          {questions.map((question, index) => {
            let field;
            if (question.type === "select") {
              const answer =
                this.state.vvoe[question.name] !== null ? this.state.vvoe[question.name] : "";
              field = (
                <LabeledInput
                  key={index}
                  inputType={question.type}
                  labelValue={question.label}
                  inputValue={answer}
                  options={question.options}
                  onChange={this.handleSelectChange.bind(this, question.name)}
                />
              );
            } else if (question.type === "date") {
              let formattedDate = "";
              if (this.state.vvoe[question.name]) {
                formattedDate = moment.utc(this.state.vvoe[question.name]).format("YYYY-MM-DD");
              }
              field = (
                <LabeledInput
                  key={index}
                  inputType={question.type}
                  labelValue={question.label}
                  inputValue={formattedDate}
                  inputName={question.name}
                  onChange={this.handleTextChange.bind(this)}
                />
              );
            } else {
              field = (
                <LabeledInput
                  key={index}
                  inputType={question.type}
                  labelValue={question.label}
                  inputValue={this.state.vvoe[question.name] || ""}
                  inputName={question.name}
                  onChange={this.handleTextChange.bind(this)}
                />
              );
            }
            return field;
          })}
        </div>
      </section>
    );
  }

  renderDocumentUploader() {
    const { app, employment } = this.props;
    return (
      <UnderwriterDocumentUploader
        documents={app.documents}
        documentType={DocTypes.WorknumberVerbalEmploymentVerification}
        prompt="Please upload Worknumber Verbal Verification of Employment"
        borrowerEntity={employment.borrower_entity}
        ownerEntityType="employment"
        ownerEntityID={employment.id}
        applicationID={app.id}
        showOnlyCurrentUploadsOfType
      />
    );
  }

  renderInfo() {
    const { employment } = this.props;
    return (
      <section className="vvoe-info">
        <h2 className="vvoe-info__title">Borrower Info</h2>
        <dl className="vvoe-info__list">
          <dt className="vvoe-info__label">Borrower Name</dt>
          <dd className="vvoe-info__value">{this.borrowerName(employment.borrower_entity)}</dd>
        </dl>
        <h2 className="vvoe-info__title">Employer Info</h2>
        <dl className="vvoe-info__list">
          <dt className="vvoe-info__label">Employer Name</dt>
          <dd className="vvoe-info__value">{employment.name}</dd>
          <dt className="vvoe-info__label">Employer Contact Info</dt>
          <dd className="vvoe-info__value">
            {employment.contact}
            {employment.contact_extension && <span> ext. {employment.contact_extension}</span>}
          </dd>
          <dt className="vvoe-info__label">Borrower's Start Date</dt>
          <dd className="vvoe-info__value">
            {
              <FormattedDate
                value={employment.start_date}
                month="long"
                day="numeric"
                year="numeric"
              />
            }
          </dd>
        </dl>
        <div className="vvoe-info__documents">
          <h2 className="vvoe-info__title">Documents</h2>
          <div className="vvoe-info__controls">
            <Select
              className="vvoe-info__dropdown"
              value={this.state.selectedDocument}
              clearable={false}
              options={this.getDocumentOptions()}
              onChange={e => this.setState({ selectedDocument: e.value })}
              placeholder="Select a document"
            />
          </div>
        </div>
      </section>
    );
  }

  renderDocument() {
    return (
      <div className="vvoe__document">
        {this.state.selectedDocument && (
          <iframe
            src={getFileDownloadBaseURL(this.state.selectedDocument)}
            width="100%"
            height="1000"
          />
        )}
      </div>
    );
  }

  render() {
    return (
      <div className="vvoe">
        {this.renderDocument()}
        <div className="vvoe__info">
          {this.renderInfo()}
          {this.renderQuestions()}
          <Button
            renderIcon={Save16}
            onClick={this.onSave.bind(this)}
            disabled={_.isEqual(
              this.state.vvoe,
              this.props.employment.verbal_verification_of_employment,
            )}
          >
            Save changes
          </Button>
        </div>
      </div>
    );
  }
}

export default VVoEForEmployment;
